const productCategory = [
  { id: 1, label: "T-Shirts", value: "tshirts" },
  { id: 2, label: "Jeans", value: "jeans" },
  { id: 3, label: "Suits", value: "suits" },
  { id: 4, label: "Skirts", value: "skirts" },
  { id: 5, label: "Jackets", value: "jackets" },
  { id: 6, label: "Sweaters", value: "sweaters" },
  { id: 7, label: "Shorts", value: "shorts" },
  { id: 8, label: "Footwear", value: "footwear" },
  { id: 9, label: "Accessories", value: "accessories" },
  { id: 10, label: "Handbags", value: "handbags" },
];

export default productCategory;
